module.exports = __webpack_public_path__ + "static/media/hwi1.c3ab90b2.webp";